<template>
    <div>
        <table class="table">
            <tbody>
                <app-list-trends-item class="btn-base" v-for="item in list" :item="item"></app-list-trends-item>
            </tbody>
        </table>
    </div>
</template>

<script>
  import ListTrendsItem from './ListTrendsItem'
  import data from '../../data/trends'

  export default {
    data () {
      return {
        list: data
      }
    },
    components: {
      appListTrendsItem: ListTrendsItem
    }
  }
</script>


